import React from 'react';
import Typewriter from 'typewriter-effect';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FormattedMessage } from 'react-intl';
import { typeWriiterStrings } from '../config/commonConfig';
import { images } from '../config/commonConfig';

const slideSettings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  lazyload: 'ondemand',
  adaptiveHeight: true,
  autoplaySpeed: 5000,
  //centerMode: true,
  fade: true,
  cssEase: 'linear',
};

const Home = ({ classicHeader, darkTheme, lang, handleNavClick }) => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-content theme-blue-bg section d-flex min-vh-100 main-padding">
          <div className="container-fluid presentation-content">
            <div className="animation-end">
              <div className=" d-inline presentation-body">
                <h1 className="slogan text-white text-uppercase">
                  <FormattedMessage
                    id="home-slogan"
                    defaultMessage="When transformation matters"
                  />
                </h1>
                <p className="presentation text-white">
                  <FormattedMessage
                    id="home-presentation"
                    defaultMessage="The demand from customers and the rapid advancement of technology require expertise in the implementation of digital products. We create high-quality web and mobile applications with cutting-edge technologies."
                  />
                </p>
                <div className="col-12 text-center flex-right">
                  <div className="writter-box">
                    <h2 className="text-4 text-white fw-600 typewritter mb-2 mb-md-3">
                      <Typewriter
                        options={{
                          strings: typeWriiterStrings[lang],
                          autoStart: true,
                          loop: true,
                        }}
                      />
                    </h2>
                    <a
                      href="#contact"
                      className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick('contact');
                      }}>
                      <FormattedMessage
                        id="home-contact"
                        defaultMessage="Contact Us"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-zone">
              <Slider {...slideSettings}>
                {images.map((image) => (
                  <div key={image.url} className="slide-wrapper">
                    <img src={image.url} className="carousel-image" />
                    <div className="slide-caption">
                      <span className="caption-text">
                        <FormattedMessage
                          id={image.captionKey}
                          defaultMessage={image.defaultCaption}
                        />
                      </span>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <a
            href="#about"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('about');
            }}>
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
